import { render } from "./GuardConfig.vue?vue&type=template&id=fd9c704e"
import script from "./GuardConfig.vue?vue&type=script&lang=js"
export * from "./GuardConfig.vue?vue&type=script&lang=js"

import "./GuardConfig.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__